import { useContactUs } from "../../../useContactUs";
import { Button } from "@growtherapy/sprout-ui";
import { CONTACT_SUPPORT_BUTTON_LABEL } from "../lang";

export function ContactSupportButton() {
  const { directFormUrl } = useContactUs();
  return (
    <Button
      onClick={() => {
        window.open(directFormUrl, "_blank");
      }}
    >
      {CONTACT_SUPPORT_BUTTON_LABEL}
    </Button>
  );
}
